import styled, { css } from "styled-components";
import type { SpaceProps } from "styled-system";
import { space } from "styled-system";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint, getDirection } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div`
    display: inline-block;
    position: relative;
    border-bottom: 1px solid ${theme.colors.grey2};
    vertical-align: middle;

    @media ${getBreakpoint("down", "md")} {
        white-space: nowrap;
    }
`;

export const Tab = styled.button<{ isActive?: boolean } & SpaceProps>`
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: auto;
    margin-${getDirection("left")}: 30px;
    padding: 0 20px 18px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    text-align: center;
    text-overflow: ellipsis;
    color: ${theme.colors.primaryBlack};
    background-color: transparent;
    border: none;
    border-radius: 0;
    outline: 0;
    ${space};

    &:first-child {
        margin-${getDirection("left")}: 0;
    }
    span {
        display: inline-block;
        line-height: 2rem;
    }
    &::after {
        display: none;
        position: absolute;
        bottom: -2px;
        ${getDirection("left")}: 0;
        width: 100%;
        height: 2px;
        content: "";
        background-color: ${theme.colors.grey1};
        z-index: 1;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            position: relative;
            font-family: ${theme.fonts.semiBold};
            font-weight: 600;
            color: ${theme.colors.primaryBlack};
            background-color: transparent;
            border-radius: 0;

            &::after {
                display: block;
                position: absolute;
                background-color: transparent;
                border: 0;
                border-bottom: 2px solid ${theme.colors.primaryRed};
            }
        `};

    /* Color variant for bz4x */
    .bz & {
        ${({ isActive }) =>
            isActive &&
            css`
                &::after {
                    border-bottom-color: ${theme.colors.bz4x};
                }
            `};
    }
`;
